// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__3MsFD","closeIcon":"Modal_closeIcon__VoczJ","header":"Modal_header__G9dzj","title":"Modal_title__bXoO5","footer":"Modal_footer__w4f7T"};